// extracted by mini-css-extract-plugin
module.exports = {"Success":"notification_Success__3Ra-p","logo":"notification_logo__16OQf"};